import TagList from '../components/TagList.vue';
import TagDetail from '../components/TagDetail.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: TagList,
    meta: {
      title: 'Tags',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/tags/list',
          title: 'Tags'
        }
      ]
    }
  },
  {
    path: ':id',
    component: TagDetail,
    meta: {
      title: 'Tag Details',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/tags/list',
          title: 'Tags'
        },
        {
          path: '',
          title: 'Tag Details'
        }
      ]
    }
  }
];
